<template>
    <div class="BlockMinitabs__inner">
        <div class="BlockMinitabs__navWrapper">
            <h2
                class="BlockMinitabs__title"
                v-if="title"
                :class="{'smaller': smallerTitle}"
            >{{ title }}</h2>
            <div class="BlockMinitabs__nav">
                <a
                    v-for="(item, index) in tabItems"
                    :key="index"
                    :class="['BlockMinitabs__navItem', { 'is-active': activeTab === index }]"
                    @click.prevent="activeTab = index"
                    href="#"
                >
                    <span class="BlockMinitabs__navTitle">{{  item.title }}</span>
                    <span v-if="item.copy" class="BlockMinitabs__navCopy" v-html="item.copy"></span>
                </a>
            </div>
        </div>
        <div class="BlockMinitabs__content">
            <template v-for="(item, index) in tabItems" :key="index" v-show="activeTab === index">
                <template v-if="activeTab === index">
                    <slot :name="'tab-' + index"></slot>
                </template>
            </template>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

const activeTab = ref(0)

defineProps({
  tabItems: {
    type: Array,
    required: true,
    default: () => []
  },
  title: {
    type: String,
    required: true
  },
  smallerTitle: {
    type: Boolean,
    default: false
  }
})
</script>